import { auth } from '../../../firebase';

const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== 'undefined' && window.location) return window.location.origin;
  return window.location.origin;
};

async function getAuthToken() {
  const currentUser = auth.currentUser;
  if (!currentUser) return null;
  try {
    return await currentUser.getIdToken(false);
  } catch {
    return null;
  }
}

/**
 * Fetch a single client by ID from the backend REST API.
 *
 * This uses the existing /api/clients/{clientId} endpoint.
 * Requires authentication — sends Firebase Bearer token.
 */
export async function getClient(clientId) {
  if (!clientId) {
    return { success: false, client: null };
  }

  const backendUrl = getBackendUrl();
  const token = await getAuthToken();

  try {
    const res = await fetch(`${backendUrl}/api/clients/${clientId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) {
      return { success: false, client: null };
    }

    const data = await res.json();
    if (!data || data.success !== true || !data.client) {
      return { success: false, client: null };
    }

    return { success: true, client: data.client };
  } catch (err) {
    console.warn('[getClient] failed to fetch client', err);
    return { success: false, client: null };
  }
}
